import { Grid2 as Grid } from "@mui/material";
import React from "react";

const StatusIndicator = ({
	color,
	label,
}: { color: string; label: string }) => (
	<Grid size="auto" container spacing={0.5} alignItems="center" wrap="nowrap">
		<Grid size="auto" display="flex" alignItems="center">
			<div
				style={{
					width: 15,
					height: 15,
					borderRadius: "50%",
					backgroundColor: color,
					border: "1px solid rgba(0,0,0,0.2)",
				}}
			/>
		</Grid>
		<Grid size="auto">
			<span style={{ whiteSpace: "nowrap" }}>{label}</span>
		</Grid>
	</Grid>
);

export const StatusBarReference = () => {
	return (
		<Grid container alignItems="center" spacing={2} wrap="nowrap" sx={{ p: 1 }}>
			<StatusIndicator color="#4caf50" label="Used in 2 days" />
			<StatusIndicator color="#ffd700" label="Used in 5 days" />
			<StatusIndicator color="#a0a0a0" label="Not used in 5 days" />
		</Grid>
	);
};
